import { Modal, Divider, Icon, Button } from 'antd';
import { Container } from '@bit/ui-common.ui-components/ss-components';

export default Container({ state: s => ({...s}), services: [] },
class extends React.Component {
    constructor(props) { super(props); }
    render() {
        const { visible, onClick } = this.props;
        return (
            <Modal 
                visible={visible}
                centered={true}
                footer={false}
                closable={false}
                width={300}
                bodyStyle={{ padding: '15px' }}
            >
                <div style={{ textAlign: 'center' }}>
                    <div>
                        <Divider style={{ 
                            margin: '0px 0px 15px 0px',
                            fontSize: '1.3em',
                            fontWeight: 'bold',
                            color: 'rgb(53, 158, 255)'
                        }}>
                            {'FTSP Session Timeout'}
                        </Divider>
                    </div>
                    <Icon type='frown' style={{ fontSize: '3.8em', margin: '0px 0px 15px 0px' }} />
                    <div style={{ fontSize: '1.6em', fontStyle: 'italic' }}>
                        {'Session has expired.'}
                    </div>
                    <div style={{ fontSize: '1.2em', fontStyle: 'italic' }}>
                        {'Please log in again.'}
                    </div>
                    <div style={{ marginTop: '20px' }}>
                        <Button
                            size='small'
                            type='primary'
                            icon='check-circle-o'
                            style={{ borderRadius: '20px', width: '200px' }}
                            onClick={onClick}
                        >
                            {'Ok'}
                        </Button>
                    </div>
                </div>
            </Modal>
        );
    }
})